export const TaskName = {
    IMAGE_EDITING: "imageediting",
    IMAGE_EDITING_QA: "imageeditingqa",
    MEASURING: "measuring",
    PHOTOGRAPHY: "photography",
};
